module.exports = __webpack_public_path__ + "images/mask-4551b28590d6699e04ffa709ee3241a9.svg";